var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { fetchProducts } from "../../redux/productsReducer";
import { store } from "../../redux/store";
import { SelectorController } from "./controllers/selector-controller";
import map from "lodash/map";
import { BasePage } from "./BasePage";
export let ProductsListPage = class ProductsListPage extends BasePage {
    constructor() {
        super(...arguments);
        this.sc = new SelectorController(this, store, (state) => state);
    }
    connectedCallback() {
        super.connectedCallback();
        store.dispatch(fetchProducts());
    }
    render() {
        const { data: products } = this.sc?.selected?.products?.products;
        console.log("products", products);
        return html ` <section className="pf-c-page__main-section pf-m-light">
      <section class="pf-c-page__main-section pf-m-fill">
        <div class="pf-l-gallery pf-m-gutter">
          ${map(products, (p) => html `<pf-card id="productlist" rounded size="compact">
              <img
                slot="header"
                src=${p.image}
                alt=${p.title}
                height="100px"
                width="100px"
              />
              <p><a href=${`/products/${p.id}`}>${p.title}</a></p>
              <div slot="footer">₹${p.price}</div>
            </pf-card>`)}
        </div>
      </section>
    </section>`;
    }
};
ProductsListPage.styles = [...BasePage.styles];
ProductsListPage = __decorate([
    customElement("product-list")
], ProductsListPage);
